import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TableContainer,
  CircularProgress,
  Paper,
  TextField,
  InputAdornment,
} from '@mui/material';
import { approveCard, listCards, rejectCard } from '../../../util/API/cardservices';
import DynamicTable from '../../DynamicTable/DynamicTable';
import BaseCustomerTable from '../../BaseCustomerTable/BaseCustomerTable';
import CustomAlert from '../../UI/CustomAlert/CustomAlert';
import SearchIcon from '@mui/icons-material/Search';

const ReveCardApproval = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [approvalCardList, setApprovalCardList] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [approvalTable, setApprovalTable] = useState(null);
  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: ""
    }
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredApprovalCardList, setFilteredApprovalCardList] = useState([]);

  const pageCount = Math.ceil(approvalCardList?.length / rowsPerPage || 0);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const handleChangePage = (event, newPage) => {
      setPage(newPage);
  };

  const getApprovalCardList = async () => {
    try {
      const response = await listCards();

      let records = response?.payload?.body?.record;

      if (!Array.isArray(records)) {
          records = records ? [records] : [];
      }

      const processedList = records.map((item) => {
          const updatedKeyvalue = item?.Globallookup?.keyvalue.replace("CARDACT:", "");
          const username = item?.Globallookup?.alternate2?.split("-").pop()
          return {
              ...item,
              Globallookup: {
                  ...item.Globallookup,
                  keyvalue: updatedKeyvalue,
                  alternate2: username
              }
          };
      });

      setApprovalCardList(processedList);
      setFilteredApprovalCardList(processedList);
    } catch (error) {
      console.log("getApprovalCardList_error-----------", error);
    } finally {
      setIsLoading(false);
    }
    
  };

  async function getTable() {
    let response = await fetch(`/tables/cardApprovalTable.json`);
    const tableData = await response.json();
    setApprovalTable(tableData);
    setRowsPerPage(tableData?.rowsPerPage);
    console.log(tableData)
  }

  useEffect(() => {
      getTable();
  }, [])

  useEffect(() => {
      getApprovalCardList();
  }, []);

  const handleButton = async(data) => {
    console.log(data)
    try {
      const response = await approveCard(data?.keyvalue, agent['User']?.id)
      console.log(response)
      if (response?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Card Approved Successfully",
        })

        getApprovalCardList()
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: `${response?.payload?.msg}`,
        })
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const handleRejectButton = async(data) => {
    console.log(data)
    try {
      const response = await rejectCard(data?.keyvalue, agent['User']?.id)
      console.log(response)
      if (response?.payload?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Card Rejected Successfully",
        })

        getApprovalCardList()
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: `${response?.payload?.msg}`,
        })
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = async() => {
    setIsLoading(true);
    console.log("approvalCardList=========",approvalCardList);
    try {
      if (!searchQuery.trim()) {
        // reset if search is empty
        setFilteredApprovalCardList(approvalCardList);
        return;
      }

      const filteredData = approvalCardList.filter(item =>
        item?.Globallookup?.keyvalue?.includes(searchQuery.trim())
      );
      setFilteredApprovalCardList(filteredData);
       setPage(0);
    } catch (error) {
      console.error('Error handleSearch card history:', error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      
        <Box
          sx={{
              marginTop: 4,
              padding: 4,
              paddingTop: 0,
              borderRadius: 4,
              backgroundColor: '#fff',
              width: '100%',
              height: "85%",
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
          }}
        >
          <Typography variant="h5" sx={{ marginBottom: 4, fontFamily: 'Nunito', color: '#333' }}>
              Card Approval
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              fontFamily: 'Nunito',
              marginBottom: '30px'
            }}
          >
            <TextField
              placeholder="Enter a card number and press enter..."
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '30px',
                  paddingLeft: 2,
                },
                maxWidth: 600,
              }}
            />
          </Box>

          {isLoading ? (
            <CircularProgress sx={{ marginTop: 4 }} />
          ) : (
            <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                {approvalTable &&<DynamicTable
                    tableData={filteredApprovalCardList}
                    tableSource={approvalTable}
                    handleButton={handleButton}
                    handleButtonText={"Approve Card"}
                    handleReject={handleRejectButton}
                    handleRejectText={"Reject Card"}
                    page={page} 
                />}

                <BaseCustomerTable
                    page={page}
                    onPageChange={handleChangePage}
                    pageNumbers={pageNumbers}
                />
            </TableContainer>
          )}
        </Box>

      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prev) => setAlert({...prev, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
    </Box>
  );
};

export default ReveCardApproval;
